import { createSafeContext } from '@mews-framework/utils';
import { CaptchaService } from './captchaService';

export const {
    CaptchaServiceContextConsumer,
    CaptchaServiceContextProvider,
    useCaptchaServiceContext: useCaptchaService,
} = createSafeContext<'CaptchaServiceContext', CaptchaService>('CaptchaServiceContext');
